import { Component, OnInit } from '@angular/core';
import {AbstractFieldComponent} from '../../abstract/abstract-field.component';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {FormFieldService} from '../../../services/form-field.service';
import {TranslateService} from '@ngx-translate/core';
import {shouldTranslate} from '../../../../core/utils/utils';

@Component({
  selector: 'app-radio-tile',
  templateUrl: './radio-tile.component.html',
  styleUrls: ['./radio-tile.component.scss']
})
export class RadioTileComponent extends AbstractFieldComponent implements OnInit {

  get highlightedImageSrc(): string {
    return 'assets/images/badge.svg';
  }

  constructor(public formFieldService: FormFieldService,
              private ts: TranslateService) {
    super(formFieldService);
  }

  ngOnInit(): void {
    this.handleStatusChanges();
  }

  async valueLabel() {
    const selectedOption = this.fieldConfig.radioConfig.find(option => option.value === this.control.value);
    if (isNotNullOrUndefined(selectedOption)) {
      const valueLabel = selectedOption.label ? selectedOption.label : selectedOption.value;
      return shouldTranslate(valueLabel) ? this.ts.instant(valueLabel) : valueLabel;
    }
    return null;
  }

  async onClick(event) {
    this.control.markAsDirty();
    setTimeout(() => {
      super.onClick(event);
    }, 0);
  }

  hasPrice(config: any): boolean {
    return config.hasOwnProperty('price') && isNotNullOrUndefined(config.price);
  }

}
